var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper flex flex-col justify-between items-stretch"},_vm._l((_vm.schema),function(element,index){return _c(element.component,{key:index,tag:"component",attrs:{"content":element.content}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }